var _excluded = ["value", "min", "max", "step", "onInput"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import Input from "../Input";
import "./style.css";

/**
 * Slider du framework 360.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
var Slider = function Slider(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 100 : _ref$max,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$onInput = _ref.onInput,
    onInput = _ref$onInput === void 0 ? null : _ref$onInput,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _React$useState = React.useState(value),
    currentValue = _React$useState[0],
    setCurrentValue = _React$useState[1];
  React.useEffect(function () {
    setCurrentValue(value);
  }, [value]);
  var handleInput = function handleInput(e) {
    var inputValue = e.target.value;
    setCurrentValue(inputValue);
    if (onInput) {
      onInput(e);
    }
  };
  return /*#__PURE__*/_jsx(Input, Object.assign({
    type: "range",
    min: min,
    max: max,
    value: currentValue,
    step: step,
    input: {
      className: 'slider',
      style: {
        padding: 0,
        backgroundImage: "-webkit-gradient(linear, left top, right top, color-stop(" + currentValue + "%, #109fdb), color-stop(" + currentValue + "%, rgba(0,0,0,.05)))"
      }
    },
    onInput: handleInput
  }, rest));
};
Slider.handledProps = ["max", "min", "onInput", "step", "value"];
Slider.propTypes = {
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  onInput: PropTypes.func
};
Slider.defaultProps = {
  value: 0,
  min: 0,
  max: 100,
  step: 1,
  onInput: null
};
export default Slider;